<template>
  <div class="space-y-2" v-if="dimensions && isAtLeastOneDimension">
    <h4 class="text-base font-medium block">
      {{ $t("artwork_details.dimensions.title") }}
    </h4>

    <div class="space-y-2 text-sm">
      <div v-if="dimensions.height" class="flex items-center space-x-2">
        <span class="font-normal">{{
          $t("artwork_details.dimensions.height")
        }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ dimensions.height }} {{ dimensions.unit }}</span>
      </div>

      <div v-if="dimensions.width" class="flex items-center space-x-2">
        <span class="font-normal">{{
          $t("artwork_details.dimensions.width")
        }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ dimensions.width }} {{ dimensions.unit }}</span>
      </div>

      <div v-if="dimensions.depth" class="flex items-center space-x-2">
        <span class="font-normal">{{
          $t("artwork_details.dimensions.depth")
        }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ dimensions.depth }} {{ dimensions.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ArtworkDimensions } from "~~/types/artwork";
import { computed } from "vue";

const props = defineProps<{
  dimensions: ArtworkDimensions | null;
}>();

const isAtLeastOneDimension = computed<boolean>(() => {
  if (!props.dimensions) return false;

  return !!(
    props.dimensions.height ||
    props.dimensions.width ||
    props.dimensions.depth
  );
});
</script>
